import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import FormContainer from "../../../../../../common/components/form_container";
import { useEffect } from "react";
import PrimaryButton from "../../../../../../common/components/primary_button";
import { BaseFormControlledModal } from "../../../../../../common/components/base_form_controlled_modal";
import { LogTipoTabela } from "../../../../../../common/utils/log_tabela_tipo";
import { defaultEntregaObraCadastroForm, EntregaObraCadastroForm, EntregaObraCadastroSchema } from "../../../schemas/entrega_obra_lista/entregaObraCadastro";
import { EntregaObraModel } from "../../../../domain/models/entrega_obra_model";
import { DropDownCentroCusto } from "../../../../../../common/components/dropdown_centro_custo";
import { FormRadioGroupInput } from "../../../../../../common/components/masked_inputs/react_forms/form_radio_group_input";


type props = {
    open: boolean,
    saving: boolean,
    loading: boolean,
    selectedEntregaObra?: EntregaObraModel | null,

    handleOpenChangeHistory: (idTabela: number | null, tipoTabela: LogTipoTabela | null) => void
    onClose: () => void,
    onSubmit: (form: EntregaObraCadastroForm) => void,
}

export const CadastroEntregaObraModal = ({
    open,
    saving,
    loading,
    selectedEntregaObra,

    handleOpenChangeHistory,
    onClose,
    onSubmit,

}: props) => {

    const statusOptions = [
        {
            id: 0,
            label: 'Em Aberto',
            style: {
                backgroundColor: '#c6c6c6',
                color: 'white',
                padding: '.2rem .4rem',
                fontSize: '0.85rem',
                fontWeight: 700,
                textShadow: '-1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000',
                borderRadius: '2px',
            },
        },
        {
            id: 1,
            label: 'Entregue',
            style: {
                backgroundColor: '#45b6af',
                color: 'white',
                padding: '.2rem .4rem',
                fontSize: '0.85rem',
                fontWeight: 700,
                textShadow: '-1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000',
                borderRadius: '2px',
            },
        }
    ];

    const hookFormCadastro = useForm<EntregaObraCadastroForm>({
        mode: "onSubmit",
        reValidateMode: "onSubmit",
        defaultValues: defaultEntregaObraCadastroForm,
        resolver: zodResolver(EntregaObraCadastroSchema),
    });

    useEffect(() => {
        if (selectedEntregaObra) {
            hookFormCadastro.setValue('idEntregaObra', selectedEntregaObra.idEntregaObra);
            hookFormCadastro.setValue('idCentroCusto', selectedEntregaObra.idCentroCusto);
            hookFormCadastro.setValue('status', selectedEntregaObra.status ?? 0);

        } else {
            hookFormCadastro.reset(defaultEntregaObraCadastroForm);
        }
    }, [selectedEntregaObra, hookFormCadastro]);

    return (
        <BaseFormControlledModal
            open={open}
            saving={saving}
            loading={loading}
            title="Cadastro de Entrega de Obra"
            confirmButtonLabel="Salvar"
            onClose={onClose}
            leftButtonSlot={
                selectedEntregaObra &&
                <div className="flex flex-row gap-2">
                    <PrimaryButton
                        buttonColor="yellow"
                        onClick={() => handleOpenChangeHistory(selectedEntregaObra?.idEntregaObra ?? null, LogTipoTabela.ENTREGA_OBRA)}>
                        <span className="text-xs">
                            Historico de alterações
                        </span>
                    </PrimaryButton>

                </div>
            }
            onSubmit={hookFormCadastro.handleSubmit(onSubmit)}>

            <FormContainer title={"Informações"} arrangement="fullRow">
                <>
                    <div className="col-span-1 md:col-span-2 lg:col-span-3">
                        <FormRadioGroupInput
                            name='status'
                            label='Status'
                            options={statusOptions}
                            readOnly={saving}
                            reactHookForm={hookFormCadastro}
                        />
                    </div>

                    <DropDownCentroCusto
                        label="Centro de Custo"
                        name="idCentroCusto"
                        reactHookForm={hookFormCadastro}
                        required
                    />

                </>
            </FormContainer>
        </BaseFormControlledModal>
    );
}